import { Contract } from '@ekt-group/general-purpose-api-interfaces';
import { ContractsSideloading } from '@ekt-group/general-purpose-api-interfaces/src/modules/contracts/types/contracts.enum';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import { ROLES_TO_CONFIRM_CONTACT_INFORMATION_POPUP } from '@/constants';
import { useUser } from '@/features/auth';
import { useGetContracts } from '@/features/contracts/api/use-get-contracts';
import { ContactInformationModal } from '@/features/contracts/components/ContactInformationModal';
import { useUserInfoStore } from '@/store';

const ContactInformationModalContainer = () => {
  const { selectedAccount } = useUserInfoStore();
  const { data: user, isLoading } = useUser();
  const [currentOutdatedContractIndex, setCurrentOutdatedContractIndex] = useState(0);
  const queryClient = useQueryClient();

  const contractsQuery = useGetContracts<Contract[]>({
    disablePagination: true,
    sideloading: [ContractsSideloading.Owner],
    ownerCodes: [selectedAccount.code],
    isContactsOutdated: true,
  });

  const hasRoleToConfirmInfo = ROLES_TO_CONFIRM_CONTACT_INFORMATION_POPUP.includes(selectedAccount.role);

  const isHidden = !hasRoleToConfirmInfo || !contractsQuery.data?.length || isLoading || (user && user.isLoggedBehalfToits);

  const handleContactInformationPopupClose = async () => {
    const nextIndex = currentOutdatedContractIndex + 1;

    if (nextIndex < contractsQuery.data?.length) {
      setCurrentOutdatedContractIndex(nextIndex);
      return;
    }

    await queryClient.invalidateQueries({
      predicate: (query) => query.queryKey.includes('contract'),
    });
  };

  if (isHidden) {
    return null;
  }

  return (
    <ContactInformationModal
      contract={contractsQuery.data[currentOutdatedContractIndex]}
      isModalOpen={true}
      handleClose={handleContactInformationPopupClose}
      afterClose={handleContactInformationPopupClose}
      required
    />
  );
};

export default ContactInformationModalContainer;
